import {useState} from 'react';
import './SelectedTeams.css';

export function TeamCrest({name, src}) {
  const [failedSrc, setFailedSrc] = useState(null);
  return <span className="fc-selected-teams__crest" aria-hidden="true">
    {src && failedSrc !== src
      ? <img src={src} alt="" onError={() => setFailedSrc(src)} />
      : <span>{name.split(/\s+/).filter(Boolean).slice(0, 2).map(word => word[0]).join('')}</span>}
  </span>;
}

function FixtureContext({team}) {
  const status = {postponed:'Fixture postponed', cancelled:'Fixture cancelled', abandoned:'Fixture abandoned', complete:'Match complete'}[team.fixtureStatus];
  const kickoff = team.kickoff && Number.isFinite(new Date(team.kickoff).getTime()) ? new Date(team.kickoff) : null;
  if (!team.opponent && !kickoff && !status) return null;
  return <p className="fc-selected-teams__fixture">
    {team.opponent && <span>v {team.opponent}</span>}
    {status ? <span>{status}</span> : kickoff && <time dateTime={kickoff.toISOString()}>{kickoff.toLocaleString('en-GB', {day:'numeric', month:'short', hour:'2-digit', minute:'2-digit', timeZoneName:'short'})}</time>}
  </p>;
}

/** A saved selection display, never a draft, eligibility check or save control. */
export default function SelectedTeams({teams, status, state, size = 'compact'}) {
  if (!teams.length) return null;
  return <div className={`fc-selected-teams fc-selected-teams--${size}`} data-selection-state={state}>
    <div className="fc-selected-teams__heading">
      <span>{teams.length > 1 ? 'Your selected teams' : 'Your selected team'}</span>
      <span className="fc-selected-teams__status">{teams.length > 1 && status === 'Pick saved' ? 'Picks saved' : teams.length > 1 && status === 'Pick locked' ? 'Picks locked' : status}</span>
    </div>
    <ul className="fc-selected-teams__list">{teams.map((team, index) => <li key={`${team.name}-${index}`}>
      <TeamCrest name={team.name} src={team.crest}/>
      <div className="fc-selected-teams__identity"><strong className="fc-selected-teams__name">{team.name}</strong><FixtureContext team={team}/></div>
    </li>)}</ul>
  </div>;
}
